import React from 'react';
import AssetCard from './AssetCard/AssetCard';
import './MainSection.css';
import Stocks from '../../../../assets/features/2.png';
import Crypto from '../../../../assets/features/3.png';
import MF from '../../../../assets/features/1.png';

const Assets = [
    {
        title: "Stocks",
        excerpt: "We are driven beyond just optimizing your portfolio. Making investing simplier and less complex is our priority",
        image: Stocks,
        link: "/stock/dashboard"
    }, {
        title: "Crypto Currencies",
        excerpt: "Crypto Currencies are the futuristic assets that can enhance the performance of your portfolio",
        image: Crypto,
        link: "/crypto/dashboard",

    }
]
const MainSection = () => {
    return (
      <div className="container main_section_container mx-auto" id="mainSection">
            <h5 className="mainHeading">
                Get Ideal Financial Solutions
            </h5>
            <h2 className="subHeading">
                Go Beyond Optimization
            </h2>
            <div className="row justify-content-evenly">
                {
                    Assets.map((asset, i) => (
                        <AssetCard asset={asset} i={i} key={i}/>
                    ))
                }
            </div>
      </div>
    )
}

export default MainSection
